import React, { createContext,useState } from 'react'
export const detailContext = createContext();
export const DetailProvider = (props)=> {
    const [state,setState] = useState({firstName:'',
    lastName:'',  
    email:'',
    date:'',
    tel:'',
    time:'',
    num_of_peoples:0,
    order_number:0});
    return (
        <detailContext.Provider value={[state,setState]}>
            {props.children}
        </detailContext.Provider>
    )
}
